'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thunkProgress = exports.all = exports.fail = exports.success = exports.inProgress = exports.none = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nullFunc = function nullFunc(r) {
  return null;
};

var findFirst = function findFirst(arr, callback) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      if (callback(el)) {
        return el;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return undefined;
};

var Progress = function () {
  function Progress() {
    (0, _classCallCheck3.default)(this, Progress);
    this.error = undefined;
  }

  (0, _createClass3.default)(Progress, [{
    key: 'map',
    value: function map(mapper) {
      return this;
    }
  }, {
    key: 'flatMap',
    value: function flatMap(mapper) {
      return this;
    }
  }, {
    key: 'fold',
    value: function fold(folder) {
      return (folder.none || nullFunc)();
    }
  }, {
    key: 'ifSuccess',
    value: function ifSuccess(func) {
      return this.fold({ success: func });
    }
  }, {
    key: 'unwrap',
    value: function unwrap() {
      throw new Error('Uncompleted progress');
    }
  }, {
    key: 'success',
    get: function get() {
      return false;
    }
  }, {
    key: 'failed',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCompleted',
    get: function get() {
      return this.failed || this.success;
    }
  }, {
    key: 'inProgress',
    get: function get() {
      return false;
    }
  }, {
    key: 'isStarted',
    get: function get() {
      return this.inProgress || this.isCompleted;
    }
  }, {
    key: 'isNone',
    get: function get() {
      return !this.isStarted;
    }
  }, {
    key: 'result',
    get: function get() {
      return undefined;
    }
  }]);
  return Progress;
}();

exports.default = Progress;

var InProgress = function (_Progress) {
  (0, _inherits3.default)(InProgress, _Progress);

  function InProgress() {
    (0, _classCallCheck3.default)(this, InProgress);
    return (0, _possibleConstructorReturn3.default)(this, (InProgress.__proto__ || Object.getPrototypeOf(InProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(InProgress, [{
    key: 'fold',
    value: function fold(folder) {
      return (folder.loading || nullFunc)();
    }
  }, {
    key: 'inProgress',
    get: function get() {
      return true;
    }
  }]);
  return InProgress;
}(Progress);

var Success = function (_Progress2) {
  (0, _inherits3.default)(Success, _Progress2);

  function Success(result) {
    (0, _classCallCheck3.default)(this, Success);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Success.__proto__ || Object.getPrototypeOf(Success)).call(this));

    _this2._result = result;
    return _this2;
  }

  (0, _createClass3.default)(Success, [{
    key: 'unwrap',
    value: function unwrap() {
      return this._result;
    }
  }, {
    key: 'fold',
    value: function fold(folder) {
      return (folder.success || nullFunc)(this._result);
    }
  }, {
    key: 'map',
    value: function map(mapper) {
      var newResult = mapper(this._result);
      return newResult === this._result ? this : new Success(newResult);
    }
  }, {
    key: 'flatMap',
    value: function flatMap(mapper) {
      return mapper(this.result);
    }
  }, {
    key: 'success',
    get: function get() {
      return true;
    }
  }, {
    key: 'result',
    get: function get() {
      return this._result;
    }
  }]);
  return Success;
}(Progress);

var Failed = function (_Progress3) {
  (0, _inherits3.default)(Failed, _Progress3);

  function Failed(error) {
    (0, _classCallCheck3.default)(this, Failed);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Failed.__proto__ || Object.getPrototypeOf(Failed)).call(this));

    _this3.error = error;
    return _this3;
  }

  (0, _createClass3.default)(Failed, [{
    key: 'fold',
    value: function fold(folder) {
      return (folder.failed || nullFunc)(this.error);
    }
  }, {
    key: 'unwrap',
    value: function unwrap() {
      throw this.error;
    }
  }, {
    key: 'failed',
    get: function get() {
      return true;
    }
  }]);
  return Failed;
}(Progress);

Progress.none = new Progress();
Progress.inProgress = new InProgress();
Progress.success = function (result) {
  return new Success(result);
};
Progress.fail = function (error) {
  return new Failed(error);
};
Progress.all = function () {
  for (var _len = arguments.length, targets = Array(_len), _key = 0; _key < _len; _key++) {
    targets[_key] = arguments[_key];
  }

  return findFirst(targets, function (p) {
    return p.failed;
  }) || findFirst(targets, function (p) {
    return p.inProgress;
  }) || findFirst(targets, function (p) {
    return p === Progress.none;
  }) || Progress.success(targets.map(function (p) {
    return p.result;
  }));
};
Progress.race = function () {
  for (var _len2 = arguments.length, targets = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    targets[_key2] = arguments[_key2];
  }

  return findFirst(targets, function (p) {
    return p.isCompleted;
  }) || findFirst(targets, function (p) {
    return p.inProgress;
  }) || targets[0] || Progress.none;
};

var action = function action(type, progress, extras) {
  return (0, _extends3.default)({}, extras, { type: type, progress: progress });
};

var none = Progress.none,
    inProgress = Progress.inProgress,
    success = Progress.success,
    fail = Progress.fail,
    all = Progress.all;
exports.none = none;
exports.inProgress = inProgress;
exports.success = success;
exports.fail = fail;
exports.all = all;
var thunkProgress = exports.thunkProgress = function thunkProgress(type, promise, extras) {
  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var progress, _result;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(action(type, Progress.inProgress, extras));
              progress = void 0;
              _context.prev = 2;
              _context.next = 5;
              return promise;

            case 5:
              _result = _context.sent;

              progress = Progress.success(_result);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](2);

              progress = Progress.fail(_context.t0);

            case 12:
              dispatch(action(type, progress, extras));
              return _context.abrupt('return', progress);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[2, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};